import DatePicker from "react-datepicker";
import { forwardRef, useEffect, useState } from "react";
import type { ForwardedRef } from "react";

import calendarIcon from "@/assets/img/calendar.svg";
import { formatDate } from "@/helper";
import "@/styles/form.scss";
import "react-datepicker/dist/react-datepicker.css";

interface Props {
    value?: Date;
    onClick?: () => void;
    className?: string;
    itemPlaceholder?: string;
    defaultValue?: Date | null;
}

const SelectDateButton = forwardRef(
    ({ value, onClick, className, defaultValue, itemPlaceholder = "" }: Props, ref: ForwardedRef<HTMLButtonElement>) => {
        const _value = defaultValue ? defaultValue : value;
        const formattedDate = _value ? formatDate(_value) : "";
        // const placeholder = showPlaceholder ? 'Event Date' : '';
        return (
            <div className={`d-flex select_date_input align-items-center ${className}`}>
                <input className="form-control bg-white" value={formattedDate} placeholder={itemPlaceholder} onClick={onClick} readOnly />
                <button className="btn calender_icon_btn" onClick={onClick} ref={ref} type="button">
                    <img src={calendarIcon} alt="calendar" />
                </button>
            </div>
        );
    },
);

interface SelectDateProps {
    label?: string;
    className?: string;
    value?: Date | null;
    placeholder?: string;
    minDate?: Date | null
    onClick: (date: Date) => void;
    containerClassName?: string;
}

export default function SelectDateInput({minDate = null, className, value, label, placeholder, onClick, containerClassName = "" }: SelectDateProps) {
    const defaultDate = value ? new Date(value) : null;
    const [selectDate, setSelectDate] = useState<Date | null>(null);

    function onSelectDateHandler(date: Date) {
        setSelectDate(date);
        onClick(date);
    }

    useEffect(() => {
        if (!selectDate) {
            setSelectDate(defaultDate);
        }
    }, [defaultDate]);

    const inputDate = selectDate ? selectDate : value;

    return (
        <div className={`select_date_input_view  d-flex flex-column form_element ${containerClassName}`}>
            {label && <label className="label">{label}</label>}
            <DatePicker
                selected={selectDate}
                minDate={minDate}
                onChange={onSelectDateHandler}
                customInput={<SelectDateButton className={className} itemPlaceholder={placeholder} defaultValue={inputDate} />}
            />
        </div>
    );
}
